const IS_SUPPORTED = typeof window !== 'undefined' && !!window.navigator.share;

export function isNavigatorShareSupported() {
  return IS_SUPPORTED;
}
